import { IMappers, ICanPostAsOwnerRequest } from '../../../repositories/commercial-owner/v1//can-post-as-owner';
import { IApplicationContext } from '../../../types/applicationContext';

export enum ECanPublishAsOwnerStatus {
  CriticalError,
  Error,
  Pending,
  Success,
}

export interface ICanPublishAsOwnerResult {
  canPostAsOwner: boolean;
  message: string | null;
  status: ECanPublishAsOwnerStatus;
}

export interface ICanPublishAsOwnerDependencies extends Pick<IApplicationContext, 'logger' | 'httpApi'> {
  parameters: ICanPostAsOwnerRequest;
}

export type TCanPublishAsOwnerMappers = IMappers<ICanPublishAsOwnerResult, ICanPublishAsOwnerResult>;
